import React, { Fragment, useState, useRef } from "react";

const CollapseInfo = ({
    children,
    headers,
    btnIcon = "",
    iconStyle = "",
    mainStyle = {},
    headerStyle = {},
    titleStyle = {},
    contentStyle = {},
    headingLineHide = false,
}: any) => {
    const [active, setActive] = useState("");
    const divElementRef = useRef(null);
    const handleActive = (i: any) => {
        if (active === i) {
            setActive("");
            return false;
        }
        setActive(i);
    };

    const handleKeyPress = (e: React.KeyboardEvent<HTMLDivElement>, i: any) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleActive(i);
        }
    }

    return Array.isArray(children)
        ? headers.map((v: any, i: any) => {
              return (
                  <Fragment key={i}>
                      {i === 0 && !headingLineHide && <div className="data-grid has-lines"></div>}
                      <div
                          className="data-grid has-lines"
                          onClick={() => handleActive(i)}
                          role="button"
                          tabIndex={0}
                          ref={divElementRef}
                          onKeyDown={(e: React.KeyboardEvent<HTMLDivElement>) => { handleKeyPress(e, i) }}
                          aria-expanded={(active === i) ? 'true' : 'false'}
                          aria-controls={`collapse-text-${i}`}
                      >
                          <div style={{ padding: "10px 0px", ...mainStyle }}>
                              <div style={{ display: "flex", alignItems: "center", ...headerStyle }}>
                                  <span className={`${btnIcon} btn-icon`}>
                                      <em className={`${iconStyle} las la-caret-down`} style={{ transform: active === i ? "rotate(180deg)" : "" }}></em>
                                  </span>
                                  <p className="collapse-title-text" style={titleStyle}>
                                      {v}
                                  </p>
                              </div>
                              {active === i ? (
                                  <p className="collapse-text" style={contentStyle} id={`collapse-text-${i}` }>
                                      {children[i]}
                                  </p>
                              ) : null}
                          </div>
                      </div>
                  </Fragment>
              );
          })
        : null;
};

export default CollapseInfo;
